module.exports = __webpack_public_path__ + "static/media/off_mic.b138b21f.svg";